export const BASE_AUTH_URL = process.env.REACT_APP_BASE_API_AUTH_URL;
export const BASE_TRANSACTIONS_URL = process.env.REACT_APP_BASE_API_TRANSACTIONS_URL;
export const BASE_DRIVER_URL = process.env.REACT_APP_BASE_API_DRIVER_URL;
export const BASE_GIOVANG_URL = process.env.REACT_APP_BASE_API_GIOVANG_URL;
export const BASE_URL = process.env.REACT_APP_BASE_WEBSITE_URL;
export const BASE_LUCKY_URL = process.env.REACT_APP_BASE_API_LUCKY_URL;
export const BASE_HEADER_URL = process.env.REACT_APP_BASE_API_HEADER_URL;
export const BASE_VOUCHER_URL = process.env.REACT_APP_BASE_API_VOUCHER_URL;
export const BASE_TRIPS_URL = process.env.REACT_APP_BASE_API_TRIPS_URL;
export const BASE_USERS_URL = process.env.REACT_APP_BASE_API_URL + 'api/users';
export const BASE_CUSTOMER_CARE_URL = process.env.REACT_APP_BASE_API_URL + 'api/customer-care';
export const BASE_PROMOTION_URL = process.env.REACT_APP_BASE_API_URL + 'api/promotions';
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
// Lấy từ REACT_APP_BASE_URL trong client .env
export const BASE_WEBSITE_URL = process.env.REACT_APP_BASE_DAT_XE_URL || '';

